export function lazyRevealImages() {
  document.querySelectorAll('[loading="lazy"]').forEach((element) => {
    const animateIn = () => {
      element.classList.add("lazyloaded")
    }

    if (element.complete) {
      animateIn()
    } else {
      element.addEventListener("load", animateIn)
    }
  })
}

// Initial call to handle already existing lazy images
lazyRevealImages()
